
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nbzxbqxzodcsxgwvwfnp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ienhicXh6b2Rjc3hnd3Z3Zm5wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU5NDU0MzcsImV4cCI6MjA2MTUyMTQzN30.hSb3vAuR_LXZGwx2dbITNUqyCejUSMtGEP8QiK90bxM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
